module.exports = __webpack_public_path__ + "img/walker.0222adde.png";